import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/movies';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

function getCategoryName(slug: string): string {
  const cat = categories.find((c) => c.slug === slug);
  return cat ? cat.name : slug;
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const location = useLocation();

  const resolvedItems = items.map((item) => {
    if (item.href && item.href.includes('/category/')) {
      const slug = item.href.split('/category/')[1];
      if (slug && slug !== 'all') {
        return { ...item, label: getCategoryName(slug) };
      }
    }
    return item;
  });

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: resolvedItems.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: item.href ? `${window.location.origin}${item.href}` : undefined,
    })),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
      <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-3">
        <div className="max-w-[1400px] mx-auto flex items-center gap-2 text-sm flex-wrap">
          {resolvedItems.map((item, index) => (
            <span key={index} className="flex items-center gap-2">
              {index > 0 && (
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-s-line text-foreground-600 text-xs"></i>
                </div>
              )}
              {item.href ? (
                <Link
                  to={item.href}
                  className="text-foreground-500 hover:text-primary-500 transition-colors"
                >
                  {item.label}
                </Link>
              ) : (
                <span className="text-foreground-300">{item.label}</span>
              )}
            </span>
          ))}
        </div>
      </nav>
    </>
  );
}

export { getCategoryName };